<div>
  <!-- Modal Header -->
  <div class="modal-header sub-info-header">
    <h4 class="modal-title bff-text bff-text--large">Mon abonnement</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body">

    <!-- Version badge -->
    <div class="sub-info-badge-row">
      <span class="sub-info-label">Version</span>
      <span [class]="badgeClass + ' sub-info-badge'">
        <i class="fas fa-user"></i>
        {{ profileLabel }}
      </span>
    </div>

    <hr class="sub-info-divider" />

    <!-- Mode de paiement -->
    <div class="sub-info-row" *ngIf="isPaid">
      <div class="sub-info-row__left">
        <i class="fas fa-credit-card sub-info-row__icon"></i>
        <span class="sub-info-row__label">Mode de paiement</span>
      </div>
      <span class="sub-info-row__value">{{ paymentMode }}</span>
    </div>

    <!-- Tarif -->
    <div class="sub-info-row">
      <div class="sub-info-row__left">
        <i class="fas fa-tag sub-info-row__icon"></i>
        <span class="sub-info-row__label">Tarif</span>
      </div>
      <span class="sub-info-row__value sub-info-row__value--highlight">{{ tarifLabel }}</span>
    </div>

    <!-- Prochaine échéance -->
    <div class="sub-info-row" *ngIf="hasEndDate">
      <div class="sub-info-row__left">
        <i class="fas fa-calendar-alt sub-info-row__icon"></i>
        <span class="sub-info-row__label">Prochaine échéance</span>
      </div>
      <span class="sub-info-row__value">{{ profileEndDate | date:'dd/MM/yy' }}</span>
    </div>

    <!-- No subscription message -->
    <div class="sub-info-free-msg" *ngIf="!isPaid">
      <i class="fas fa-info-circle"></i>
      Vous utilisez la version gratuite. Passez à une version supérieure pour accéder à plus de fonctionnalités.
    </div>

  </div>

  <!-- Modal Footer -->
  <div class="modal-footer sub-info-footer bff-button-container bff-button-container--preserve-desktop">
    <button
      type="button"
      class="bff-button bff-button--secondary bff-button--with-left-icon bff-button--no-mobile-style"
      (click)="activeModal.dismiss()"
    >
      <i class="fa fa-times"></i>
      <span>Fermer</span>
    </button>
    <button
      type="button"
      class="bff-button bff-button--primary bff-button--with-left-icon bff-button--no-mobile-style"
      (click)="openChangeVersion()"
    >
      <i class="fas fa-exchange-alt"></i>
      <span>Changer de version</span>
    </button>
  </div>
</div>
